export const parseBreadcrumbParent = (search, state) => {
  const params = new URLSearchParams(search);

  let parentType = params.get("parent_type") || state?.parentType || null;
  let parentId = params.get("parent_id") || state?.parentId || null;
  let parentLabel = params.get("parent_label") || state?.parentLabel || null;

  const projectIdFromUrl = params.get("project_id");
  const sprintIdFromUrl = params.get("sprint_id");

  if (!parentType && projectIdFromUrl) {
    parentType = "project";
    parentId = projectIdFromUrl;
  } else if (!parentType && sprintIdFromUrl) {
    parentType = "sprint";
    parentId = sprintIdFromUrl;
  }

  return { parentType, parentId, parentLabel };
};

export const appendBreadcrumbSearch = (path, breadcrumbParent = {}) => {
  if (!breadcrumbParent?.parentType) {
    return path;
  }

  const [pathname, existingSearch = ""] = path.split("?");
  const params = new URLSearchParams(existingSearch);

  params.set("parent_type", breadcrumbParent.parentType);

  if (breadcrumbParent.parentId) {
    params.set("parent_id", breadcrumbParent.parentId);
  }
  if (breadcrumbParent.parentLabel) {
    params.set("parent_label", breadcrumbParent.parentLabel);
  }

  const search = params.toString();
  return search ? `${pathname}?${search}` : pathname;
};
